import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuelidate from "vuelidate";
import "./assets/globalcss/style.css";
import "./assets/globalcss/typography.css";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
// Import Bootstrap and BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import SingleSelect from "./components/SingleSelect.vue";
import MobileNameheader from "@/components/MobileNameheader.vue";

// Make BootstrapVue available throughout your project
Vue.use(Vuelidate);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.component("SingleSelect", SingleSelect);
Vue.component("MobileNameheader", MobileNameheader);
Vue.config.productionTip = false;

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
